import getWidgetMode from '~/shared/utils/getWidgetMode';

const isStandaloneAppPath = (): boolean =>
  getWidgetMode() === 'standalone';

export default isStandaloneAppPath;
